/*
 * @Author: yong.wang webwang1@outlook.com
 * @Date: 2026-06-03 15:07:21
 * @LastEditTime: 2026-07-20 09:55:31
 * @LastEditors: yong.wang webwang1@outlook.com
 * @Description: 文件说明
 * Copyright (c) 2026 by webwang1, All Rights Reserved.
 */
import store from '@/store';
import { message } from 'ant-design-vue';
import axios from 'axios';
import router from '../../router';

const service = axios.create({
  baseURL: process.env.VUE_APP_PORTAL_API_BASE,
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
});

if (process.env.VUE_APP_PORTAL_API_KEY) {
  service.defaults.headers.common['Api-Key'] = process.env.VUE_APP_PORTAL_API_KEY;
}

service.interceptors.request.use(
  (config) => {
    config.data = JSON.stringify(config.data);
    if (!config.headers) {
      config.headers = {};
    }
    let token = store.getters.get_Signin_info;
    let user = store.getters.get_user_Info_cache;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      if (user)
        config.headers['X-MTR-EVOUCHER-PORTAL-CONTACTID'] = user.contactId;
    }
    if (
      store.getters.get_locale_setting != null &&
      store.getters.get_locale_setting == 'en-US'
    ) {
      config.headers['Accept-Language'] = 'en-US';
    } else {
      config.headers['Accept-Language'] = 'zh-CN';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          store.dispatch('setSignininfo', '');
          setTimeout(() => {
            router.replace({
              path: '/401',
              query: {
                token_expire: 1
              }
            });
          }, 1000);
          break;
        case 404:
          message.error('网络请求不存在');
          break;
        case 500:
          if (error.response.data && error.response.data.message) {
            message.error(error.response.data.message);
          } else {
            message.error('服务器内部错误');
          }
          break;
        default:
          if (error.response.data && error.response.data.message) {
            message.error(error.response.data.message);
          } else {
            message.error('请求失败');
          }
          break;
      }

      return Promise.reject(error.response);
    } else if (error.request) {
      message.error('网络请求超时，请检查网络连接');
      return Promise.reject(error);
    } else {
      message.error('请求配置错误');
      return Promise.reject(error);
    }
  }
);

// /**
//  * 封装post请求
//  * @param url
//  * @param data
//  * @returns {Promise}
//  */

function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    service.post(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    service.patch(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    service.put(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
const get = (url, ...params) => {
  return new Promise((resolve, reject) => {
    service
      .get(url, {
        params: params
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
// export const post = (url, ...params) => {
//   return new Promise((resolve, reject) => {
//     axios.post(url, QS.stringify(...params))
//       .then(res => {
//         resolve(res.data)
//       })
//       .catch(err => {
//         reject(err.data)
//       })
//   })
// }
export default {
  post: post,
  get: get,
  put: put,
  patch: patch
};
